export const getAppUser = /* GraphQL */ `
  query getAppUser($app_user_id: String!) {
    getAppUser(app_user_id: $app_user_id) {
      _name
      _state
      app_user_id
      email
      language
      phone
      surname
      username
      c_description
      crm_id
      customer_id
      latitude
      logo
      longitude
      state
      ragione_sociale
      zoom
      map_style
      user_map_style
    }
  }
`;

export const listTranslations = /* GraphQL */ `
  query listTranslations($lang: String!) {
    listTranslations(lang: $lang) {
      label_code
      label_value
      lang
    }
  }
`;

export const listAppUserPolicy = /* GraphQL */ `
  query listAppUserPolicy($input: listAppUserPolicyInput!) {
    listAppUserPolicy(input: $input) {
      REPORT_HUB {
        father_id
        node_description
        node_id
        node_name
        path_s3_bucket
        service_id
        sort_id
        crm_folder
        crm_id
        starting_year
      }
      DOC {
        father_id
        node_description
        node_id
        node_name
        path_s3_bucket
        service_id
        sort_id
      }
      URL {
        father_id
        external_link
        node_description
        node_id
        node_name
        service_id
        sort_id
      }
      WS {
        service_id
        service_name
        description
        service_type
        manual_s3_path
        service_state
        ws_id
        ws_name
        ws_group
        animation_limit_date_type
        animation_limit_future
        animation_limit_past
        animation_step_date_type
        archive_start_date
        animation_step
        refresh_interval_step_type
        refresh_interval_step
        meteograms {
          meteogram_id
          location_name
          latitude
          longitude
        }
        ws_policy {
          pws_id
          policy_id
          service_id
          is_graph
          is_animation
          is_table
          is_meteogram
          is_map
          skip_wmts_calls
          start_date
          end_date
          date_type
          layer_name
          ws_id
          layer_type
          layer_color
          aggregation_interval
          layer_opacity
          layer_label
          is_multi_variable
          multi_variable_layers
          multi_variable_layer_configs {
            layer_name
            source_udm
            target_udm
            udm
            layer_color
          }
          source_udm
          target_udm
          udm
          domain_id
          layer_style
        }
      }
      TICKET {
        service_id
        ticket_id
        date_limit
        config {
          document_id
          document_type
          default_next_business_days
          default_approfondimento_next_business_days
          meteo_types {
            meteo_id
            name
            is_auto
            is_manual
            is_approfondimento
            next_business_days
            approfondimento_next_business_days
          }
        }
      }
    }
  }
`;

export const listEnabledServicesPolicy = /* GraphQL */ `
  query listEnabledServicesPolicy($input: listEnabledServicesPolicyInput!) {
    listEnabledServicesPolicy(input: $input) {
      DOC {
        app_user_id
        manual_s3_path
        description
        policy_id
        service_id
        service_name
        service_state
        service_type
      }
      URL {
        app_user_id
        manual_s3_path
        description
        policy_id
        service_name
        service_state
        service_type
        service_id
      }
      WS {
        app_user_id
        manual_s3_path
        description
        policy_id
        service_name
        service_state
        service_type
        service_id
        info_app
        info_policy
      }
      TICKET {
        enabled_service {
          app_user_id
          app_user_ticket_id
          manual_s3_path
          description
          policy_id
          service_name
          service_state
          service_type
          service_id
        }
        permissions {
          service_id
          node_id
          father_id
          node_name
          node_description
          sort_id
          permission_id
          permission_type
          permission_name
          surname
          email
          phone
          crm_id
          ragione_sociale
          _name
        }
      }
      ALERT_EXP {
        app_user_id
        manual_s3_path
        description
        policy_id
        service_name
        service_state
        service_type
        service_id
      }
      REPORTS {
        app_user_id
        manual_s3_path
        description
        policy_id
        service_name
        service_state
        service_type
        service_id
      }
      REPORT_HUB {
        app_user_id
        manual_s3_path
        description
        policy_id
        service_id
        service_name
        service_state
        service_type
        crm_folder
      }
    }
  }
`;

export const listEvasionLimitSlots = /* GraphQL */ `
  query listEvasionLimitSlots($dates_to_check: [String]!) {
    listEvasionLimitSlots(dates_to_check: $dates_to_check) {
      evasion_limit
      max_slots
      total_slots
      is_prov
      can_be_moved
    }
  }
`;

export const listTicketingNonOperationalWindows = /* GraphQL */ `
  query listTicketingNonOperationalWindows($fromDate: String, $mergeOverlapping: Boolean) {
    listTicketingNonOperationalWindows(
      from_date: $fromDate
      merge_overlapping: $mergeOverlapping
    ) {
      window_id
      start_date
      end_date
      window_type
      min_evasion_days
    }
  }
`;

export const listComuniProvince = /* GraphQL */ `
  query listComuniProvince($is_prov: Boolean!) {
    listComuniProvince(is_prov: $is_prov) {
      list
    }
  }
`;

export const listDocumentMeteoTypes = /* GraphQL */ `
  query listDocumentMeteoTypes($type: String!) {
    listDocumentMeteoTypes(type: $type) {
      list
    }
  }
`;

export const getTicketingServiceConfiguration = /* GraphQL */ `
  query getTicketingServiceConfiguration($service_id: String!) {
    getTicketingServiceConfiguration(service_id: $service_id) {
      service_id
      ticket_id
      date_limit
      config {
        document_id
        document_type
        default_next_business_days
        default_approfondimento_next_business_days
        meteo_types {
          meteo_id
          name
          is_auto
          is_manual
          is_approfondimento
          next_business_days
          approfondimento_next_business_days
        }
      }
      check_date {
        puntuale
        comunale
      }
    }
  }
`;

export const getTicketingRequest = /* GraphQL */ `
  query getTicketingRequest($input: [GetTicketingRequestInput]!) {
    getTicketingRequest(input: $input) {
      service_id
      request_id
      request_type
      app_user_id
      app_user_ticket_id
      document_type
      evasion_date
      evasion_limit
      request_date
      request_state
      notes
      additional_notes
      locations {
        request_id
        location_id
        latitude
        longitude
        meteo_type
        address
        start_date
        end_date
      }
      node_id
      father_id
      node_name
      node_description
      sort_id
      policy_id
      username
      request_number
      request_count
      full_address
      surname
      email
      phone
      crm_id
      ragione_sociale
      _name
      full_name
    }
  }
`;

export const getLinkedDocumentS3toTicketingRequest = /* GraphQL */ `
  query getLinkedDocumentS3toTicketingRequest($request_id: String!) {
    getLinkedDocumentS3toTicketingRequest(request_id: $request_id) {
      app_user_ticket_id
      request_id
      request_type
      document_s3_id
      file_name
      document_creator
      document_s3_path
    }
  }
`;

export const listTicketingRequestLimit = /* GraphQL */ `
  query listTicketingRequestLimit($crm_id: [String]!) {
    listTicketingRequestLimit(crm_id: $crm_id) {
      crm_id
      request_limit
      request_count
      limit_reached
    }
  }
`;

export const getGlobalLayer = /* GraphQL */ `
  query getGlobalLayer($crm_id: String) {
    getGlobalLayer(crm_id: $crm_id) {
      global_layer_id
      layer_name
      layer_description
      layer_polygon
      color
      width
      layer_type
    }
  }
`;

export const getCustomerGlobalLayer = /* GraphQL */ `
  query getCustomerGlobalLayer($crm_id: String) {
    getCustomerGlobalLayer(crm_id: $crm_id) {
      global_layers {
        global_layer_id
        layer_name
        layer_description
        layer_polygon
        color
        width
        layer_type
      }
      customer_layers {
        crm_id
        global_layer_id
        layer_name
        layer_description
        layer_polygon
        color
        width
        layer_type
      }
    }
  }
`;

export const getCustomerLayer = /* GraphQL */ `
  query getCustomerLayer($crm_id: String!) {
    getCustomerLayer(crm_id: $crm_id) {
      crm_id
      global_layer_id
      layer_name
      layer_description
      layer_polygon
      color
      width
      layer_type
    }
  }
`;

export const listServiceManuals = /* GraphQL */ `
  query listServiceManuals($app_user_id: String!) {
    listServiceManuals(app_user_id: $app_user_id) {
      service_id
      service_name
      service_type
      service_ws_group
      manual_s3_path
    }
  }
`;

export const listCustomerManuals = /* GraphQL */ `
  query listCustomerManuals($customer_id: String!) {
    listCustomerManuals(customer_id: $customer_id) {
      manual_s3_path
      label_code
      label_value
      customer_id
    }
  }
`;

export const listFolderObjects = /* GraphQL */ `
  query listFolderObjects($input: ListFolderObjectsInput!) {
    listFolderObjects(input: $input) {
      list
    }
  }
`;

export const listVideoTutorial = /* GraphQL */ `
  query listVideoTutorial($video_id: Int) {
    listVideoTutorial(video_id: $video_id) {
      video_id
      title
      description
      url
      sort_id
    }
  }
`;

export const getDefaultService = /* GraphQL */ `
  query getDefaultService($input: GetDefaultServiceInput!) {
    getDefaultService(input: $input) {
      GLOBAL {
        default_id
        service_type
        app_scope
        service_path
        drawer_title
        global_layer_id {
          id
          name
        }
        customer_layer_id {
          id
          name
        }
        service_details {
          service_id
          layer_name
          layer_type
          is_meteogram
          service_name
        }
        timeStamp_token
      }
      Archive {
        default_id
        service_type
        app_scope
        service_path
        drawer_title
        global_layer_id {
          id
          name
        }
        customer_layer_id {
          id
          name
        }
        service_details {
          service_id
          layer_name
          layer_type
          is_meteogram
          service_name
        }
        timeStamp_token
      }
      RealTime {
        default_id
        service_type
        app_scope
        service_path
        drawer_title
        global_layer_id {
          id
          name
        }
        customer_layer_id {
          id
          name
        }
        service_details {
          service_id
          layer_name
          layer_type
          is_meteogram
          service_name
        }
        timeStamp_token
      }
      Forecast {
        default_id
        service_type
        app_scope
        service_path
        drawer_title
        global_layer_id {
          id
          name
        }
        customer_layer_id {
          id
          name
        }
        service_details {
          service_id
          layer_name
          layer_type
          is_meteogram
          service_name
        }
        timeStamp_token
      }
    }
  }
`;
